module.exports = __webpack_public_path__ + "operace-previsleho-bricha-abdominoplastika_11_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-previsleho-bricha-abdominoplastika_11_before.jpg
// module id = 1178
// module chunks = 0